module.exports = __webpack_public_path__ + "img/cover.12839f8d.jpg";